import React, { useState, useEffect } from "react";
import {
  ButtonBase,
  ThemeProvider,
  theme,
  BetaForm as useBetaForm,
  TextInputBase,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

const newTheme = {
  ...theme,
  variants: {},
};

export default function SetPasswordModal(props: any) {
  const [data, setData] = useState<any>(null);
  const form = useBetaForm({
    email: "",
    password: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    password: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          {data ? (
            <div className={"relative border-b bg-green-50 text-green-500"}>
              <div className="px-4 lg:px-8">
                <div className="relative py-6 text-center">
                  <h2 className="text-xl font-semibold tracking-tight">
                    Password Set Successfully
                  </h2>
                </div>
              </div>
            </div>
          ) : (
            <div className={"relative border-b " + props.color}>
              <div className="px-4 lg:px-8">
                <div className="relative py-6 text-center">
                  <h2 className="text-xl font-semibold tracking-tight">
                    {props.heading}
                  </h2>
                </div>
              </div>
            </div>
          )}
          <div className="p-4 w-2xl">
            {data ? (
              <div className="mt-2 min-h-max text-center text-base text-gray-500">
                User's password has been successfully updated. User can now use
                new password to log in.
              </div>
            ) : (
              <div className="mt-2 space-y-4 w-full">
                <div>
                  <TextInputBase
                    labelBaseProps={{
                      label: "Email*",
                    }}
                    name={"email"}
                    onChange={(val) => form.setField("email", val)}
                    placeholder={"Enter user's email"}
                    type={"text"}
                    error={
                      form.errors.get("email") ? (
                        <p className="mt-2 text-sm text-red-500">
                          {form.errors.get("email")[0]}
                        </p>
                      ) : null
                    }
                    value={form.getField("email")}
                    htmlFor={"email"}
                    disabled={props.type === "edit"}
                  />
                </div>
                <div>
                  <TextInputBase
                    labelBaseProps={{
                      label: "Password*",
                    }}
                    name={"password"}
                    onChange={(val) => form.setField("password", val)}
                    placeholder={"Enter password"}
                    type={"text"}
                    error={
                      form.errors.get("password") ? (
                        <p className="mt-2 text-sm text-red-500">
                          {form.errors.get("password")[0]}
                        </p>
                      ) : null
                    }
                    value={form.getField("password")}
                    htmlFor={"password"}
                  />
                </div>
              </div>
            )}
          </div>
          {data ? (
            <div className="flex justify-center items-center py-4 border-t">
              <ButtonBase
                variant="primary"
                type="button"
                label={"Exit"}
                onClick={async () => {
                  props.onAction("no");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-red-600 hover:bg-red-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "px-8 py-3",
                }}
              />
            </div>
          ) : (
            <div className="flex justify-center items-center py-4 border-t">
              <ButtonBase
                variant="primary"
                type="button"
                label={"Set Password"}
                onClick={async () => {
                  form.value.email = form.value.email.trim().toLowerCase();
                  if (form.validate()) {
                    const data = await props.callback(form, form.value);
                    if (data) {
                      setData(data);
                      // props.onAction("no");
                    }
                  }
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "px-8 py-3",
                }}
              />
            </div>
          )}
        </div>
      </div>
    </ThemeProvider>
  );
}
